/**
 * What the counters of this host need, as the server writes it into the page (the
 * backend's app/seo/fragments.py, put in by the gateway): data in a script element that
 * does not run. Absent at the team's hosts, without a counter, and where the page did not
 * pass the gateway (a test, Vite alone): then nothing is counted.
 */
export const ANALYTICS_ELEMENT = 'easymusic-analytics';

export interface AnalyticsConfig {
  yandexMetrika?: { id: number; webvisor: boolean };
}

export function readAnalyticsConfig(doc: Document = document): AnalyticsConfig | null {
  const text = doc.getElementById(ANALYTICS_ELEMENT)?.textContent;
  if (!text) return null;
  try {
    const value: unknown = JSON.parse(text);
    return value && typeof value === 'object' ? (value as AnalyticsConfig) : null;
  } catch {
    return null;
  }
}
